/* app/js/src/components/clipping-studio/shared/color-swatch-picker/clipping-studio-color-swatch-picker.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: block;
}
.color-swatch-picker {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 8px;
  gap: 0 12px;
}
.color-swatch-picker__item {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.14);
  padding: 0;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
}
.color-swatch-picker__item::before {
  content: "";
  position: absolute;
  top: -6px;
  bottom: -6px;
  left: -6px;
  right: -6px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 50%;
  transform: scale(0.7);
  opacity: 0;
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.color-swatch-picker__item:hover::before {
  transform: scale(1);
  opacity: 1;
}
.color-swatch-picker__item--selected::before {
  transform: scale(1);
  opacity: 1;
  border-width: 2px;
  border-color: var(--swatch-ring-color, rgba(0, 0, 0, 0.85));
}
.color-swatch-picker__item--picker {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  border-color: transparent;
  background: transparent;
}
.color-swatch-picker__item--picker ::ng-deep .color-circle {
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.54) !important;
  background:
    conic-gradient(
      from 0deg,
      #ff0000,
      #ff8000,
      #ffff00,
      #00ff00,
      #00ffff,
      #0000ff,
      #ff00ff,
      #ff0000) !important;
}
.color-swatch-picker__item--picker ::ng-deep .color-circle.selected:before {
  display: none;
}
.color-swatch-picker__item--transparent {
  background: repeating-conic-gradient(rgba(0, 0, 0, 0.14) 0% 25%, transparent 0% 50%) 50%/24px 24px;
  border-color: rgba(0, 0, 0, 0.14);
}
/*# sourceMappingURL=clipping-studio-color-swatch-picker.component.css.map */
